// extracted by mini-css-extract-plugin
export default {"leftNavigation":"CarouselLeft_leftNavigation__5V9no"};